import { useTranslate } from 'react-admin'

function LoadingScreen() {
  const t = useTranslate()
  return <div className="flex justify-center items-center h-[100vh]"> {t("ra.page.loading")} ...</div>
}


export default LoadingScreen